/* eslint-disable eqeqeq */
/* eslint-disable no-console */
// import { IconManifest, icons } from 'react-icons';

import { GDTApiErrors } from '@/types';
import {
  DetalleMovimientoCuentaMobileTO,
  FormTransferirSaldo,
  FormTransferirSaldoCheck,
  IconMovimiento,
  RequestUbicacionMapa,
  ResponseComprarProducto,
  ResponseDetallePaquetePin,
  ResponseFormPayu,
  ResponseMiCuenta,
  ResponseMontosCarga,
  ResponseProductosDisponibles,
  ResponseTarjetasTokenizadas,
  ResponseTransaccionesPendientesVisa,
  ResponseTransferenciaSaldo,
  ResponseUbicacionMapa,
  TarjetaTokenizada,
} from '@/types/myAccount';
import { EnumEstadoPin, EnumEstadoPinMensaje } from '@/types/pins';
import { URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';
import {
  axiosErrorHandler,
  isApiError,
  isApiTimeout,
  promiseTimeout,
} from '@/utils/functions';

/**
 * Initial data for "My Account" section
 */
export const initMyAccount = axiosErrorHandler(async () => {
  const url = URLs.MI_CUENTA.INIT;

  const response = await axiosGdt.get<ResponseMiCuenta | GDTApiErrors>(url);
  return response.data;
}, 'Error al obtener datos');

/**
 * get available products for sale.
 */
export const getProducts = axiosErrorHandler(async () => {
  const url = URLs.MI_CUENTA.PRODUCTOS_DISPONIBLES;

  const response = await axiosGdt.get<
    ResponseProductosDisponibles | GDTApiErrors
  >(url);
  return response.data;
}, 'Error al obtener datos');

export const initMyAccountExtra = axiosErrorHandler(async () => {
  const [products, initData] = await Promise.all([
    getProducts(),
    initMyAccount(),
  ]);
  return {
    products,
    initData,
  };
}, 'Error al obtener datos');

type ProductoParam = {
  /**
   * Format: int32
   * @description id de producto
   */
  id: number;
  /** @description precio actual (customizado para usuario por oferta) */
  precio: number;
};

/**
 * Starts the purchase of a product,
 * when the price is lower than the account balance.
 */
export const purchaseWithAvailableFunds = axiosErrorHandler(
  async (product: ProductoParam) => {
    const url = URLs.MI_CUENTA.COMPRA_CON_SALDO;
    const params = {
      id: product.id,
      precioEsperado: product.precio,
    };
    const response = await axiosGdt.post<
      ResponseComprarProducto | GDTApiErrors
    >(url, undefined, { params });

    return response;
  }
);

/**
 * Gets the suggested recharge amounts.
 */
export const getRechargeAmounts = axiosErrorHandler(async () => {
  const url = URLs.MI_CUENTA.MONTOS;

  const response = await axiosGdt.get<ResponseMontosCarga | GDTApiErrors>(url);
  return response.data;
}, 'Error al obtener datos');

/**
 * Lista de TC usadas anteriormente (pero tokenizadas).
 * El form de pago recibe sÃ³lo tokenizadas[].token
 * ver https://en.wikipedia.org/wiki/Tokenization_(data_security)
 * Vos le mostrÃ¡s al usuario la informaciÃ³n mÃ­nima de la tarjeta para identificarla (ver doc de la lista de tokenizadas).
 */
const getTokenizadas = axiosErrorHandler(
  async (keyTarjeta: TarjetaTokenizada['codigoMedioPagoGdt']) => {
    const url = URLs.MI_CUENTA.TOKENIZADAS;

    const response = await axiosGdt.get<
      ResponseTarjetasTokenizadas | GDTApiErrors
    >(url);
    const theData = response.data;
    if (isApiError(theData)) {
      return theData;
    }
    return filterTokenizadas(keyTarjeta, theData);
  },
  'Error al obtener datos'
);

function filterTokenizadas(
  keyTarjeta: TarjetaTokenizada['codigoMedioPagoGdt'],
  theData: ResponseTarjetasTokenizadas
): ResponseTarjetasTokenizadas {
  if (theData.warning) {
    console.warn(theData.warning);
    console.warn('%c ' + theData.warning, 'color: red; font-size: 18px');
  }
  const listaTokenizadas = theData.tokenizadas || [];
  const tokenizadas = listaTokenizadas.filter(function (elem) {
    return elem.codigoMedioPagoGdt === keyTarjeta;
  });

  return {
    ...theData,
    tokenizadas,
  };
}

/**
 * USAR ESTE.
 * <br>
 * 10seg de timeout.
 * getTokenizadasConTimeout("visa")
 * @param keyTarjeta
 * @returns
 */
export function getTokenizadasConTimeout(
  keyTarjeta: TarjetaTokenizada['codigoMedioPagoGdt']
) {
  return Promise.race([promiseTimeout(10000), getTokenizadas(keyTarjeta)]).then(
    function (response) {
      if (isApiTimeout(response)) {
        const warning = 'listarTokenizadas: timeout 10s';
        console.warn(warning);
        return {
          warning,
          tokenizadas: [],
        };
      }
      return response;
    }
  );
}

export const getTransaccionesPendientes = axiosErrorHandler(async () => {
  const url = URLs.MI_CUENTA.TRX_PENDIENTES;

  const response = await axiosGdt.get<
    ResponseTransaccionesPendientesVisa | GDTApiErrors
  >(url);
  const theData = response.data;
  // if (isApiError(theData)){    return theData;  }
  return theData;
}, 'Error al obtener datos');

// async function exampleGetTransaccionesPendientes() {
//   const resp = await getTransaccionesPendientes();
//   if (isApiError(resp)) {
//     // estado false. No se espera un error acÃ¡. continÃºo (que falle en el siguiente paso).
//     return;
//   }
//   if (resp.blacklist) {
//     console.error('mostrale al usuario:' + resp.blacklist_msg);
//     return;
//   }

//   let msgConfirm = '';
//   if ((resp.minTrxAnterior || -1) > 0) {
//     msgConfirm =
//       'Tu Ãºltima transacciÃ³n exitosa fue hace ' +
//       resp.minTrxAnterior +
//       ' minutos.Â¿QuerÃ©s continuar de todos modos?';
//   } else if ((resp.minsRestantes || -1) > 0) {
//     msgConfirm =
//       'TenÃ©s una transacciÃ³n en procesamiento, esperÃ¡ ' +
//       resp.minsRestantes +
//       ' minutos y volvÃ© a chequear tus movimientos.Â¿QuerÃ©s continuar de todos modos?';
//   }
//   console.error(msgConfirm);
//   /* if (msgConfirm == "" || confirm(msgConfirm)) {
//     CONTINUA CON EL SIGUIENTE PASO (post a formulario de gateway de pagos, ~ decidir, aka payway)
//   */
// }
/* 
let globalThis2 = globalThis as unknown as {__getTransaccionesPendientes: (typeof exampleGetTransaccionesPendientes) };
globalThis2.__getTransaccionesPendientes = exampleGetTransaccionesPendientes
*/

/**
 * @param monto obligatorio, formateado en inglÃ©s (positivo, con punto, mÃ¡ximo dos decimales. "dd.dd")
 * @param no obligatorio. id de tipo de producto.
 */
export const getPrepareSendPayu = axiosErrorHandler(
  async (monto: string, tipoProducto?: number) => {
    let url = URLs.MI_CUENTA.PAYU_SEND;
    url += '?';
    url += `monto=${encodeURIComponent(monto)}`;
    if (tipoProducto) {
      url += `&tipoProducto=${encodeURIComponent(tipoProducto)}`;
    }

    const response = await axiosGdt.post<ResponseFormPayu | GDTApiErrors>(url);
    const theData = response.data;
    return theData;
  },
  'Error al obtener datos'
);

/**
 * create FORM element
 */
function createForm(url: string, params: { [key: string]: string }) {
  const myForm = document.createElement('form');
  myForm.method = 'post';
  myForm.action = url;
  myForm.target = '_self';
  myForm.acceptCharset = 'UTF-8';

  for (const iParam in params) {
    const inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = iParam;
    inp.value = params[iParam];
    if (typeof params[iParam] === 'object') {
      inp.value = JSON.stringify(params[iParam]);
    }

    myForm.appendChild(inp);
  }
  return myForm;
}

export async function redirectToPayU(monto: string, tipoProducto?: number) {
  const response = await getPrepareSendPayu(monto, tipoProducto);
  if (isApiError(response)) {
    console.warn('toast:' + response.mensaje);
    return;
  }
  const form = createForm(response.url, response.form);
  document.body.appendChild(form);
  form.submit();
}

/**
 * @param params form de transferencai
 */
export const transferMoneyConfirm: (
  params: FormTransferirSaldo
) => Promise<ResponseTransferenciaSaldo> = axiosErrorHandler(
  async (params: FormTransferirSaldo) => {
    const url = URLs.MI_CUENTA.TRANSFERIR_SALDO_ENVIO;
    const response = await axiosGdt.post<ResponseTransferenciaSaldo>(
      url,
      undefined,
      { params }
    );
    return response.data;
  },
  'Error al obtener datos'
);

/**
 * @param params form de transferencai
 */
export const transferMoneyCheck = axiosErrorHandler(
  async (paramsRaw: FormTransferirSaldoCheck) => {
    let url = URLs.MI_CUENTA.TRANSFERIR_SALDO_CONSULTA;
    const paramsAsString = Object.fromEntries(
      Object.entries(paramsRaw).map(([k, v]) => [k, v + ''])
    );
    url += '?' + new URLSearchParams(paramsAsString).toString();
    const response = await axiosGdt.get<ResponseTransferenciaSaldo>(url);
    return response.data;
  },
  'Error al obtener datos'
);

/**
 * Ejemplo de uso de las funciones de transferencia de saldo
 */
// async function exampleTransfer() {
//   const r = mapSearch({
//     lat: -34.6901943,
//     lng: -58.5087264,
//     maxCant: 3,
//     km2: '50',
//     // "proveedores": "SEAC"
//   });
//   console.log('r:', r);
//   /*
//   let r = await transferMoneyCheck({tipoDoc: 1, nroDoc: 51});
//   if (isApiError(r)){
//     console.warn("toast:" + r.mensaje);
//     return;
//   }
//   let r2 = await transferMoneyConfirm({tipoDoc: 1, nroDoc: 51, montoATransf: 500, opcionMotivo: 1});
//   console.log("r2:", r2);
//   */
// }

/**
 * bÃºsqueda en el mapa
 */
export const mapSearch = axiosErrorHandler(
  async (params: RequestUbicacionMapa) => {
    const url = URLs.MI_CUENTA.BUSQUEDA_MAPA;
    const response = await axiosGdt.post<ResponseUbicacionMapa | GDTApiErrors>(
      url,
      params,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  }
);

/**
 * detalle de paquete de pines
 */
export const getDetallePaquete = axiosErrorHandler(async (idMov) => {
  const url = URLs.MI_CUENTA.DETALLE_PAQUETE;
  const params = {
    idMov,
  };
  const response = await axiosGdt.get<ResponseDetallePaquetePin>(url, {
    params,
  });
  return response.data;
}, 'Error al obtener datos');

type EnumTipoProductoItem = {
  id: number;
  icon: IconMovimiento;
};

export const EnumTipoProducto: {
  [key: string]: EnumTipoProductoItem;
} = {
  PIN: { id: 1, icon: 'pin' },
  PAQUETE: { id: 3, icon: 'pack' },
  PAQUETE_5: { id: 5, icon: 'pack' },
  PAQUETE_25: { id: 25, icon: 'pack' },
  PIN_F5: { id: 12, icon: 'pin' },
  USUARIO_PREMIUM: { id: 19, icon: 'premium' },
  TRANSFERIR_SALDO: { id: 26, icon: 'transferencia' },
  PIN_REGALO_A_F5: { id: 27, icon: 'pin' },
  PIN_TAP_1: { id: 30, icon: 'pin' },
  PIN_TAP_2: { id: 31, icon: 'pin' },
  PIN_TAP_3: { id: 32, icon: 'pin' },
  PIN_FEORO: { id: 33, icon: 'pin' },
  PIN_PREEXISTENTE: { id: 37, icon: 'pin' },
};

type ETipoPinItem = {
  id: number;
  txt1: string;
  txt2?: string;
  esTap?: boolean;
};

export const PIN_TDA_TITLE = 'Pin Especial Torneo de Amigos';
export const ETipoPin: {
  [key: string]: ETipoPinItem;
} = {
  PIN_WEB: { id: 0, txt1: 'PIN' },
  PIN_F5: { id: 4, txt1: 'PIN F5', txt2: 'F5' },
  PIN_A: { id: 16, txt1: 'PIN A', txt2: 'A' },

  PIN_TAP_1: { id: 19, txt1: 'Pin Especial TdA por Premios (1)', esTap: true },
  PIN_TAP_2: { id: 20, txt1: 'Pin Especial TdA por Premios (2)', esTap: true },
  PIN_TAP_3: { id: 21, txt1: 'Pin Especial TdA por Premios (3)', esTap: true },

  PIN_FEORO: { id: 22, txt1: 'Pin Especial Fecha de Oro' },
};

export function getEnumTipoProductoById(
  id: number
): EnumTipoProductoItem | undefined {
  return Object.values(EnumTipoProducto).find((elem) => {
    return elem.id == id;
  });
}

export function getEstadoByPinId(id: number | undefined): string | undefined {
  if (id) {
    if (id !== EnumEstadoPin.USADO) {
      return EnumEstadoPinMensaje.VIGENTE;
    } else {
      return EnumEstadoPinMensaje.USADO;
    }
  }

  return '';
}

export function getETipoPinById(id: number): ETipoPinItem | undefined {
  return Object.values(ETipoPin).find((elem) => {
    return elem.id == id;
  });
}

export function calculateIcon(
  mov: DetalleMovimientoCuentaMobileTO
): IconMovimiento {
  if (mov.tipoProductoGDT) {
    const enumProd = getEnumTipoProductoById(mov.tipoProductoGDT);
    if (!enumProd) {
      return 'pin';
    }
    return enumProd.icon;
  }
  return 'carga';
}

/*
let globalThis2 = globalThis as unknown as {__testCuentas: (typeof exampleTransfer) };
globalThis2.__testCuentas = exampleTransfer

let globalThis2 = globalThis as unknown as {__testCuentas: (typeof examplePrepareFormPayu) };
globalThis2.__testCuentas = examplePrepareFormPayu
*/
